"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.function_dPower = function_dPower;
exports.function_display_file = function_display_file;
var _mathjs = require("mathjs");
/**
* Nom : util.js
* Description : Ce fichier rassemble des fonctions réutilisables dans plusieurs parties de l'application.
* Date de création : 24 aout 2026
*/

/* CSS et assets */
// None

/* Bibliothèques et composants */

/* Hook */
// None

/**
* function_dPower : cette fonction evalue une fonction à partir d'une expresion litérale
*
* Type : function 
*
* Parametres : 
*  expression
*  distance
*/
function function_dPower(expression, distance) {
  var dPower = (0, _mathjs.evaluate)(expression, {
    x: Number(distance)
  });
  return dPower.toFixed(2);
}
;

/**
* function_display_file : cette fonction affiche le nom d'un fichier sans le code ajouté par l'application
*
* Type : function 
*
* Parametres : 
*  filmename
*/
function function_display_file(filename) {
  var filename_list = filename.split("_");
  var extension = filename_list.at(-1).split(".").at(-1);
  filename_list.pop();
  var corrected_filename = filename_list.join("_") + "." + extension;
  return corrected_filename;
}
;